import { createFileRoute, notFound } from "@tanstack/react-router";

import { BackendResponseError } from "@/api/backendClient";
import { maintenanceStrategiesQueries } from "@/api/resources/maintenanceStrategies/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import MaintenanceStrategyPage from "@/components/MaintenanceStrategy/MaintenanceStrategyPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute(
  "/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/",
)({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.maintenance-strategies"),
        icon: <Icon.MAINTENANCE_STRATEGIES />,
        path: "/workspaces/$workspace_id/maintenance-strategies",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, maintenance_strategy_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentMaintenanceStrategy = await context.queryClient
      .ensureQueryData(maintenanceStrategiesQueries.byId(maintenance_strategy_id))
      .catch((error: unknown) => {
        // the backend answers 404 for strategies that don't exist or aren't visible to the user
        if (error instanceof BackendResponseError && error.status === 404) throw notFound();
        throw error;
      });
    if (!currentMaintenanceStrategy) throw notFound();

    const breadcrumbs: BreadcrumbsContext[] = [
      { label: currentMaintenanceStrategy.title, icon: <Icon.MAINTENANCE_STRATEGY /> },
    ];
    context.breadcrumbs.splice(2, 1, ...breadcrumbs);
  },
  component: MaintenanceStrategyPage,
});
